import { render } from "./ManufacturingOperationVideosModal.vue?vue&type=template&id=05d7c1e2"
import script from "./ManufacturingOperationVideosModal.vue?vue&type=script&lang=js"
export * from "./ManufacturingOperationVideosModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__